export default {
  code: "4XZNS2HMPB",
  app: "f6210355a042dbf13430a45b67f0118f",
};